import { FC } from 'react';

import { BottomSheet } from '../../../BottomSheet';
import { Modal, ModalFooterProps } from '../../../Modal';
import { useMedia } from '../../../useMedia';
import { DIALOG_DESKTOP_QUERY } from '../query';

export type ResponsiveDialogFooterProps = ModalFooterProps;

/** Modal.Footer (кнопки в ряд) на десктопе, BottomSheet.Footer (кнопки стопкой) на мобайле. */
const ResponsiveDialogFooter: FC<ResponsiveDialogFooterProps> = (props) => {
  const isDesktop = useMedia(DIALOG_DESKTOP_QUERY);

  return isDesktop ? <Modal.Footer {...props} /> : <BottomSheet.Footer {...props} />;
};

export default ResponsiveDialogFooter;
